module.exports = __webpack_public_path__ + "static/first-5-california-logo-e0768809d57804aba619d83dd6973388.png";